module.exports = __webpack_public_path__ + "static/media/view6.b1340956.jpg";